import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/periodos-de-seguro-imss/';
export const baseURI2 = 'catalogos/catalogo-de-concepto-periodicidad-de-seguridad-social';

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosPagoIMSS = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoPagoIMSS = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoPagoIMSS = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Seguridad Social
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoPagoIMSS = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoPagoIMSS = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Nivel de Estudio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPeriodoPagoIMSS = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConceptosPeriodosPagoSS = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
